// import { UmSelectionControl } from './selection-control.js';
//
// export abstract class UmCheckboxBase extends UmSelectionControl {
//   @property({ type: Boolean }) checked;
// }
